import moment from "moment-timezone";
import { t } from "ttag";
import { IQueueRetention } from "../../models/Queues.types";

/** A retention with neither an age nor a count says nothing, so it is treated as absent. */
export const hasRetention = (retention?: IQueueRetention | null): retention is IQueueRetention =>
  !!retention && !!(retention.age || retention.count);

/**
 * How long a finished job is kept, in words. A job goes when it passes either limit, and BullMQ
 * trims by age only as other jobs finish, so the date is when it becomes eligible for removal.
 */
export const describeRetention = (retention?: IQueueRetention | null): string => {
  if (!hasRetention(retention)) {
    return "";
  }

  const kept = retention.age ? moment.duration(retention.age, "seconds").humanize() : "";
  const count = retention.count ? retention.count.toLocaleString() : "";

  if (kept && count) {
    return t`Eligible for removal after ${kept}, or once the queue holds more than ${count} finished jobs`;
  }

  if (kept) {
    return t`Eligible for removal after ${kept}`;
  }

  return count ? t`Only the newest ${count} finished jobs are kept` : "";
};
